import { AfterViewInit, Component, OnInit, computed, signal, WritableSignal, OnDestroy, ChangeDetectorRef, effect, ViewChild, ElementRef } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { SelectedComponent } from "../../shared/selected/selected.component";
import { ListsService } from '../../services/lists.service';
import { LocationsComponent } from "../../shared/locations/locations.component";
import { ConfigInput, ConfigSelected } from '../../interfaces/interfaces';
import { InputComponent } from "../../shared/input/input.component";
import { IndependentComponent } from "../../shared/independent/independent.component";
import { AutomaticDebitComponent } from "../../shared/automatic-debit/automatic-debit.component";
import { AssociatedComponent } from "../../shared/associated/associated.component";
import { PensionersComponent } from "../../shared/pensioners/pensioners.component";
import { AgriculturalComponent } from "../../shared/agricultural/agricultural.component";
import { SecurityService } from '../../services/security.service';
import { Router } from '@angular/router';
import { ModalComponent } from "../../shared/modal/modal.component";
import { RouteService } from '../../services/route.service';
import { toast } from 'ngx-sonner';
import { HelpService } from '../../services/help.service';

@Component({
  selector: 'app-address',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    SelectedComponent,
    LocationsComponent,
    InputComponent,
    IndependentComponent,
    AutomaticDebitComponent,
    AssociatedComponent,
    PensionersComponent,
    AgriculturalComponent,
    ModalComponent
  ],
  templateUrl: './address.component.html',
  styleUrl: './address.component.css'
})
export class AddressComponent implements OnInit, AfterViewInit, OnDestroy {
  form: FormGroup;
  resetTimer = signal(false);
  asotipId = signal(0);
  isValidAddress = signal(false);
  allowAddres = false;
  showQuotaModal = signal(false);
  defaultData: WritableSignal<any> = signal({});
  nextRoute: WritableSignal<string> = signal('');
  @ViewChild('address') addressInput!: ElementRef<HTMLInputElement>;
  isChecked = false;

  
  // Señal computada para validación reactiva
  isValidData = computed(() => {
    const data = this.defaultData();
    const asotip = this.asotipId();
    const formValid = this.form.valid;
    
    return this.validateAllData();
  });

  dataInputs: WritableSignal<ConfigInput[]> = signal([
    { label: 'Dirección de Domicilio', subLabel: '', formName: 'address', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(8), Validators.maxLength(55)], textError: 'Por favor escribe una dirección válida mayor a 8 y menor a 55 carácteres' },
    { label: 'Barrio Domicilio', subLabel: '', formName: 'neighborhood', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required, Validators.minLength(3), Validators.maxLength(30)], textError: 'Por favor ingresa un barrio mayor a 3 y mayor a 30 caracteres' },
  ]);

  dataSelected: WritableSignal<ConfigSelected[]> = signal([
    { label: '¿Cuál es tu ocupación?', subLabel: '', formName: 'asotip', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona un elemento de la lista', options: signal([]) },
    { label: 'Zona en la que vives', subLabel: '', formName: 'zone', placeholder: '', type: 'text', defaultValue: '', enabled: true, validation: [Validators.required], textError: 'Por favor selecciona una zona', options: signal([{ value: 1, label: 'Rural' }, { value: 2, label: 'Urbana' }]) },
  ]);

  constructor(
    private _title: Title,
    private _loaderService: LoaderService,
    private _listService: ListsService,
    private _securityService: SecurityService,
    private _router: Router,
    private _routeService: RouteService,
    private _helpService: HelpService,
    
  ) {
    this._title.setTitle('Onboarding Digital | Datos extra');

    this.form = new FormGroup({
      asotip: new FormControl(null, Validators.required),
      location: new FormControl(null, Validators.required),
      address: new FormControl(null, Validators.required),
      neighborhood: new FormControl(null, Validators.required),
      zone: new FormControl(null, Validators.required),
    });

    this.nextRoute.set(this._routeService.getNextRoute(this._router.url) ?? '');
    this.form.get('asotip')?.valueChanges.subscribe((value: string | number) => {
      this.handleAsotipChange();
      this.asotipId.set(Number(value));
    });

    // Effects para debugging
    effect(() => {
      // console.log('defaultData cambió:', this.defaultData());
    });

    effect(() => {
      // console.log('currentData cambió:', this.currentData());
    });

    effect(() => {
      // console.log('isValidData computado:', this.isValidData());
    });
  }

  ngOnInit(): void {
    this._helpService.show();
    this.getAsotip();
  }
  
  ngAfterViewInit(): void {
    this.getDataAddress();
    this._loaderService.hide();
  }

  ngOnDestroy(): void {
  }

  getDataAddress() {
    this._securityService.getAddressData()
    .subscribe({
      next: (response: any) => {
        if (response) {
          this.defaultData.set(response.addressData);
          this.asotipId.set(this.defaultData().asotip);
          
          this.dataInputs.update((inputs: any) =>
            inputs.map((input: any) => ({
              ...input,
              defaultValue: response.addressData[input.formName] ?? input.defaultValue
            }))
          );

          this.dataSelected.update((inputs: any) =>
            inputs.map((input: any) => ({
              ...input,
              defaultValue: response.addressData[input.formName] ?? input.defaultValue
            }))
          );
        }
      },
      error: (error: any) => {
        console.error("ERROR: ", error);
      }
    });
  }

  getAsotip() {
    this._listService.getAsotip().subscribe({
      next: (response: any) => {
        this.dataSelected().at(0)?.options.set(response);
      },
      error: (error: any) => {
        console.error("ERROR: ", error);
      }
    });
  }

  setLocation(location: any) {
    if(this.defaultData().location != location){
      this.form.get('location')!.setValue(location);

      this.defaultData.update(currentData => ({
        ...currentData,
        location: location
      }));
    }
  }

  handleValue(event: { formName: string, value: string | number }) {
    this.form.get(event.formName)?.setValue(event.value);
    this.defaultData.update(currentData => ({
      ...currentData,
      [event.formName]: event.value
    }));
  }

  handleEvent(data: any, type: number) {
    if(this.defaultData().income !== data.income && data.income != '' && data.income != null){
      this._securityService.calculateQuota(data.income).subscribe({
        next: (response: any) => {
          this.showQuotaModal.set(true);
          this.defaultData.update(currentData => ({
            ...currentData,
            calculatedQuota: Number(response.data).toLocaleString('es-ES')
          }));
        },
        error: (error: any) => {
          console.error('Error', error);
        }});
    }


    this.defaultData.update(currentData => ({
      ...currentData,
      ...data
    }));
  }

  private handleAsotipChange() {
    this.defaultData.set(({
      ...this.form.value
    }));
  }

  private validateAutomaticDebitData(data: any): boolean {
    if (!('automaticDebit' in data)) {
      return false;
    }

    if (data.automaticDebit === false) {
      return true;
    }

    if (data.automaticDebit === true && data.debitType === 'INTERNO') {
      return true;
    }

    if (data.automaticDebit === true && data.debitType === 'EXTERNO') {
      return this.validateObjectAttributes(data, [
        'bank',
        'accountNumber',
        'accountType',
        'debitDay'
      ]);
    }

    return false;
  }

  private validateObjectAttributes(obj: any, keys: string[]): boolean {
    if (!obj) return false;

    for (const key of keys) {
      const value = obj[key];

      if (
        value === null ||
        value === undefined ||
        (typeof value === 'string' && value.trim() === '')
      ) {
        return false;
      }
    }

    return true;
  }

  validateAllData(): boolean {
    const currentData = this.defaultData();
    const currentAsotipId = this.asotipId();
    const isFormValid = this.form.valid;

    if (!isFormValid) {
      return false;
    }


    if (currentAsotipId == 1) {
      const independentValid = this.validateObjectAttributes(currentData, [
        'indact',
        'academic',
        'specialProtecionProgram',
        'econmicActivity',
        'income',
        'codpro',
      ]);
      if (!independentValid) return false;

      if (!currentData) return false;

      return this.validateAutomaticDebitData(currentData);
    }

    if (currentAsotipId == 2) {
      return this.validateObjectAttributes(currentData, [
        'since',
        'codpro',
        'academic',
        'company',
        'specialProtecionProgram',
        'income',
      ]);
    }

    if (currentAsotipId == 3) {
      return this.validateObjectAttributes(currentData, [
        'fonpen',
        'since',
        'codpro',
        'academic',
        'specialProtecionProgram',
        'income',
      ]);
    }

    if (currentAsotipId == 5) {
      return this.validateObjectAttributes(currentData, [
        'indact',
        'codpro',
        'academic',
        'specialProtecionProgram',
        'income',
      ]);
    }

    return true;
  }

  onSubmit() {
    if (this.isValidData()) {
      if(!this.allowAddres){
      this._loaderService.show();
      this._securityService.checkAddress(this.form.get('address')?.value)
      .subscribe({
        next: (response: any) => {
          if(response.result === 'INCORRECTA'){
            this.allowAddres = false;
            this.isValidAddress.set(true);
            this._loaderService.hide()
          }else{
            this.defaultData.update(currentData => ({
              ...currentData,
              isAddressConfirmed: false
            }));
            this.saveData();
          }
        },
        error: (err: any) => {
          this._loaderService.hide()
        }
      });
      }else{
        this.saveData();
      }
    } else {
      toast.error('Faltan datos por completar');
    }
  }

  saveData() {
    this._loaderService.show();
    this._securityService.setAddressData(this.defaultData())
      .subscribe({
        next: (response: any) => {
          this._router.navigateByUrl(this.nextRoute());  
      },
      error: (err: any) => {
        this._loaderService.hide();
        this.isValidAddress.set(true);
      }
    });
  }

  backValidateAddress(){
    this.isValidAddress.set(false);
     this.addressInput.nativeElement.focus();
      this.addressInput.nativeElement.select();
  }

  onCheckboxChange(event: any) {
    this.isChecked = event.target.checked;
  }

  validateAddress(){
    this.defaultData.update(currentData => ({
      ...currentData,
      isAddressConfirmed: true
    }));
    this.isValidAddress.set(false);
    this.allowAddres = true;
  }
}